export default "__VITE_ASSET__BQxm062k__"